// Colori delle pagine V2, in un unico posto, con il valore per il tema chiaro e per quello scuro.
// Nei componenti si usano come variabili CSS (var(--rt-nome)), così cambiano con il tema senza ricalcoli;
// dove serve il valore (es. attributi SVG dei grafici) si legge da TOKENS[mode].
// I valori chiari sono quelli usati finora: il tema chiaro resta identico.

export const TOKENS = {
  light: {
    page: '#FFFFFF',
    paper: '#FFFFFF',
    ink: '#1F2A24',
    heading: '#374151',
    muted: '#6B7468',
    faint: '#A3ABA2',
    line: '#E4E9E1',
    'pill-border': '#D5DBD2',
    'pill-border-hover': '#9AA59A',
    subtle: '#F7F9F6',
    'subtle-2': '#FAFBF9',
    hover: '#F6F8F4',
    track: '#EEF1EC',
    'ring-track': '#E7ECE4',
    'green-soft': '#EEF6E9',
    'green-dark': '#3B7F2C',
    'grey-50': '#fafafa',
    'grey-100': '#f5f5f5',
    // tabelle mensili e worklog
    'grid-line': '#eef0f2',
    'grid-border': '#dfe3e6',
    weekend: '#f7f7f8',
    'row-sub': '#fafbfa',
    'row-open': '#f1f7ee',
    'row-team': '#f3f6f2',
    'row-team-weekend': '#eef1ee',
    'today-head': '#e2f1db',
    'today-outline': '#9aa5ad',
    // testi di stato
    danger: '#c62828',
    'danger-strong': '#B3261E',
    'danger-dark': '#b71c1c',
    warn: '#9a4400',
    amber: '#6B5200',
    'amber-2': '#8a5a00',
    'amber-3': '#a66b00',
    // forecast
    forecast: '#1976d2',
    'forecast-soft': '#e3f2fd',
    'forecast-ink': '#0d47a1',
    'forecast-cell': '#f3f8fe',
    // calendario del mese (Home, Track hours)
    'cal-ok': '#F1F8EC',
    'cal-partial': '#FDF4D7',
    'cal-under': '#FDE6D2',
    'cal-missing': '#FBE3E2',
    'cal-absence': '#FBE9E8',
    'cal-weekend': '#F6F7F5',
    // trasparenze neutre
    hairline: 'rgba(0,0,0,0.08)',
    'hairline-2': 'rgba(0,0,0,0.12)',
    placeholder: 'rgba(0,0,0,0.3)',
    'prefix-bg': 'rgba(255,255,255,0.7)',
    overlay: 'rgba(255,255,255,0.6)',
    // marchio Avvale in trasparenza sullo sfondo
    'watermark-opacity': '0.4',
  },
  dark: {
    page: '#121613',
    paper: '#1A1F1C',
    ink: '#E6EBE4',
    heading: '#E6EBE4',
    muted: '#9DA89C',
    faint: '#6F7A6E',
    line: '#2B332D',
    'pill-border': '#3A453C',
    'pill-border-hover': '#5E6B5F',
    subtle: '#1E2420',
    'subtle-2': '#1C221E',
    hover: '#232B25',
    track: '#2A322C',
    'ring-track': '#2A322C',
    'green-soft': '#1E3320',
    'green-dark': '#8BD16A',
    'grey-50': '#1C211E',
    'grey-100': '#262C28',
    'grid-line': '#262D28',
    'grid-border': '#343D36',
    weekend: '#161A17',
    'row-sub': '#1C221E',
    'row-open': '#1F2B21',
    'row-team': '#202722',
    'row-team-weekend': '#1B211D',
    'today-head': '#24402A',
    'today-outline': '#7C8A80',
    danger: '#FF8A80',
    'danger-strong': '#FF8A80',
    'danger-dark': '#FF8A80',
    warn: '#FFB27A',
    amber: '#F0C460',
    'amber-2': '#EDBE66',
    'amber-3': '#F2C46B',
    forecast: '#82B9F2',
    'forecast-soft': '#17304A',
    'forecast-ink': '#A9D1FA',
    'forecast-cell': '#15212D',
    'cal-ok': '#1E2B1F',
    'cal-partial': '#343019',
    'cal-under': '#3B2A1C',
    'cal-missing': '#3A2020',
    'cal-absence': '#33201F',
    'cal-weekend': '#1A1E1B',
    hairline: 'rgba(255,255,255,0.14)',
    'hairline-2': 'rgba(255,255,255,0.2)',
    placeholder: 'rgba(255,255,255,0.35)',
    'prefix-bg': 'rgba(255,255,255,0.08)',
    overlay: 'rgba(18,22,19,0.6)',
    'watermark-opacity': '0.3',
  },
  // Neri assoluti per schermi OLED: pagina e card nere, separazione affidata ai bordi (le ombre sul nero non si vedono),
  // testo grigio chiarissimo invece del bianco puro per evitare l'effetto alone
  oled: {
    page: '#000000',
    paper: '#000000',
    ink: '#E6E6E6',
    heading: '#E6E6E6',
    muted: '#9E9E9E',
    faint: '#6B6B6B',
    line: '#262626',
    'pill-border': '#333333',
    'pill-border-hover': '#555555',
    subtle: '#0D0D0D',
    'subtle-2': '#0A0A0A',
    hover: '#161616',
    track: '#1F1F1F',
    'ring-track': '#1F1F1F',
    'green-soft': '#0F2410',
    'green-dark': '#8BD16A',
    'grey-50': '#0D0D0D',
    'grey-100': '#1A1A1A',
    'grid-line': '#1A1A1A',
    'grid-border': '#2A2A2A',
    weekend: '#080808',
    'row-sub': '#0A0A0A',
    'row-open': '#0E1A10',
    'row-team': '#111111',
    'row-team-weekend': '#0C0C0C',
    'today-head': '#163A1C',
    'today-outline': '#6E6E6E',
    danger: '#FF8A80',
    'danger-strong': '#FF8A80',
    'danger-dark': '#FF8A80',
    warn: '#FFB27A',
    amber: '#F0C460',
    'amber-2': '#EDBE66',
    'amber-3': '#F2C46B',
    forecast: '#82B9F2',
    'forecast-soft': '#0E2238',
    'forecast-ink': '#A9D1FA',
    'forecast-cell': '#08121C',
    'cal-ok': '#0F1F10',
    'cal-partial': '#2A2510',
    'cal-under': '#2E1F10',
    'cal-missing': '#2E1414',
    'cal-absence': '#281414',
    'cal-weekend': '#0A0A0A',
    hairline: 'rgba(255,255,255,0.16)',
    'hairline-2': 'rgba(255,255,255,0.22)',
    placeholder: 'rgba(255,255,255,0.35)',
    'prefix-bg': 'rgba(255,255,255,0.08)',
    overlay: 'rgba(0,0,0,0.6)',
    'watermark-opacity': '0.3',
    // sidebar nera (negli altri temi resta quella predefinita)
    'sidebar-bg': '#000000',
    'sidebar-hover': '#161616',
    'sidebar-border': '1px solid #262626',
    'sidebar-sheen': 'none',
    'sidebar-shadow': 'none',
  },
};

/** Variabile CSS di un colore: da usare negli sx e negli stili. */
export const v = (name) => `var(--rt-${name})`;

/** Dichiarazioni CSS delle variabili per un tema (per GlobalStyles su :root). */
export const cssVariables = (mode) => Object.fromEntries(Object.entries(TOKENS[mode]).map(([k, value]) => [`--rt-${k}`, value]));
